import { WorldDataHelper } from 'Utility/WorldDataHelper';
import { IFieldData } from 'State/World/IFieldData';

export function getFieldNameFromId(fieldId: FieldSectorId): string {
    return getFieldFromId(fieldId).field;
}

export function getFieldSectorFromId(fieldId: FieldSectorId): number {
    return getFieldFromId(fieldId).sector;
}

export type FieldSector = {
    field: string;
    sector: number;
}

export function getFieldFromId(fieldId:FieldSectorId):FieldSector {
    const ids = fieldId.split("_");
    return  {
        field: ids[0],
        sector: Number(ids[1]),
    };
}

/**
 * Type alias to distinguish dynamic field-sector ID strings.
 * TODO: Replace field Id string instances with type alias.
 * TODO: Use type-guard when reading from data to assert valid FieldSectorId type.
 */
export type FieldSectorId = string;

/**
 * Get the field & sector identifier.
 * TODO: Replace instances of string concatenation to use this method.
 * @param fieldId
 * @param sectorId
 */
export function getFieldSectorId(fieldId: string, sectorId: number): FieldSectorId {
    return `${fieldId}_${sectorId}`;
}

/**
 * Get all field IDs unlocked at the specified level up to the specified world number.
 * @param level
 * @param world
 */
export function getUnlockedFields(level: number, world: number): FieldSectorId[] {
    const fields: FieldSectorId[] = [];

    WorldDataHelper.getAllFieldData(world).forEach(field => {
        field.requiredLevel.forEach((requiredLevel, index) => {
            if (level >= requiredLevel) {
                fields.push(getFieldSectorId(field.id, index));
            }
        });
    });

    return fields;
}

/**
 * Get the associated field data given the field Id.
 * TODO: Highly un-optimized. Please refactor.
 * @param fieldId
 */
export function getFieldData(fieldId: FieldSectorId): IFieldData {
    return WorldDataHelper.getAllFieldData().find(field => field.id === getFieldNameFromId(fieldId));
}
